var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7063 6.71571C15.0597 6.35911 15.0571 5.78351 14.7005 5.43008C14.3439 5.07664 13.7683 5.07921 13.4149 5.43581L11.2969 7.57274C10.4374 8.44001 9.84582 9.03492 9.34457 9.43747C8.85767 9.8285 8.54492 9.96264 8.26482 9.99834C8.08895 10.0208 7.91099 10.0208 7.73512 9.99834C7.45502 9.96264 7.14227 9.8285 6.65537 9.43747C6.15412 9.03492 5.56256 8.44001 4.703 7.57275L2.58505 5.43581C2.23162 5.07921 1.65602 5.07664 1.29941 5.43008C0.942812 5.78351 0.940244 6.35911 1.29368 6.71571L3.44978 8.89115C4.26183 9.7105 4.92554 10.3802 5.51689 10.8551C6.13183 11.3489 6.756 11.7064 7.50523 11.8019C7.83375 11.8438 8.16619 11.8438 8.49471 11.8019C9.24394 11.7064 9.86811 11.3489 10.483 10.8551C11.0744 10.3802 11.7381 9.71051 12.5501 8.89116L14.7063 6.71571Z",
    fill: "#349FD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/accordion.4df2c887e707aaca4a56d9f221a4f4b7.svg";
export { ForwardRef as ReactComponent };